class MetricsHelper {
  full (data) {
    var template = {
      packets: '-',
      bytes: '-',
      unicast: '-',
      broadcast: '-',
      multicast: '-',
      pauses: '-',
      errors: '-',
      crcErrors: '-'
    }
    return Object.assign(template, data)
  }
  lastFive (data) {
    var template = {
      packets: '-',
      bytes: '-'
    }
    return Object.assign(template, data)
  }
  port (data) {
    var template = {
      errors: '-',
      crcErrors: '-',
      bytes: '-',
      multicast: '-',
      unicast: '-'
    }
    return Object.assign(template, data)
  }
}
export default new MetricsHelper()



// WEBPACK FOOTER //
// ./src/projects/access-gui/helpers/metrics.js